import script from "./BillableGauge.vue?vue&type=script&setup=true&lang=js"
export * from "./BillableGauge.vue?vue&type=script&setup=true&lang=js"

import "./BillableGauge.vue?vue&type=style&index=0&id=fc3d606e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc3d606e"]])

export default __exports__